import React from 'react';
import GlobalHeader from './globalHeader';
import OrganisationHeader from './organisationHeader';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const HeaderView = () => {
  return /*#__PURE__*/_jsxs("header", {
    children: [/*#__PURE__*/_jsx(GlobalHeader, {}), /*#__PURE__*/_jsx(OrganisationHeader, {})]
  });
};
export default HeaderView;